import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=af6f83b8&scoped=true&"
import script from "./LeadsTable.vue?vue&type=script&lang=js&"
export * from "./LeadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6f83b8",
  null
  
)

export default component.exports